import { useSelector } from "react-redux";
import { AppStore } from "../../store";
import { CreditProfile } from "./credit-profile";

export const useGetCreditProfile = () => {
  return useSelector<AppStore, CreditProfile | undefined>(
    (store) => store.creditProfileState.profile
  );
};
